const DEFAULT_AUTH0_DOMAIN = "dev-7wy4y0gf.eu.auth0.com";
const DEFAULT_AUTH0_CLIENT_ID = "OZ2UCvWAMbwBqLNmnqyGZjNauQp5tKXD";
export const AUTH0_DOMAIN = process.env.VUE_APP_AUTH0_DOMAIN ? process.env.VUE_APP_AUTH0_DOMAIN : DEFAULT_AUTH0_DOMAIN;
export const AUTH0_CLIENT_ID = process.env.VUE_APP_AUTH0_CLIENT_ID ? process.env.VUE_APP_AUTH0_CLIENT_ID : DEFAULT_AUTH0_CLIENT_ID; 

export const DISABLE_AUTH = process.env.VUE_APP_DISABLE_AUTH === 'true';
